
<div class="modal-header">
  <h3 class="modal-title">Editar Actividad</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <form  (ngSubmit)="submitForm()">
    <div class="form-group">
      <label class="text-form">Asunto</label>
      <input
        type="text"
        class="form-control style-asunto"
        name="asunto"
        #asunto="ngModel"
        [(ngModel)]="newActivity.subject"
        >
    </div>
    <div class="form-group">
      <label for="" class="text-form">Texto</label>
      <textarea
        class="form-control style-textarea"
        name="texto"
        #texto="ngModel"
        [(ngModel)]="newActivity.content"
        rows="3"
        cols="40"
        >
      </textarea>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-6">
          <label for="" class="text-form">Fecha:</label>
        </div>
        <div class="col-md-6">
          <label for="" class="text-form">Hora:</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 date-activity">
          <div class="input-group">
            <input
              class="form-control style-datepicker"
              placeholder="Seleccionar fecha"
              name="Fecha_Actividad"
              [(ngModel)]="model1"
              (ngModelChange)="changeMaxDate($event)"
              #Fecha_Actividad="ngModel"
              ngbDatepicker #d1="ngbDatepicker"
              [minDate]="mindate"
              [readonly]="true"
              [placement]="'bottom-left'"
              >
            <div class="input-group-append style-button">
              <button class="btn fas fa-calendar-alt bt" (click)="d1.toggle();" type="button"></button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <ngb-timepicker
            [(ngModel)]="timeActivity"
            [meridian]="meridian"
            class="timePicker"
            name="time_actv"
            >
          </ngb-timepicker>
        </div>
      </div>
    </div>
    @if (showReminder) {
      <div class="form-group reminder">
        <label for="" class="text-form">Repetir</label>
        <div class="row pt-1">
          <div class="col-md-8">
            <p class="text_reminder">{{text_reminder}}</p>
          </div>
          <div class="col-xs-2 pl-2">
            <a type="button" class="icon-table" (click)="modifyReminder()"><i class="fas fa-edit"></i></a>
          </div>
          <div class="col-md-2 check">
            <input class="color_checkbox" type="checkbox" name="reminder_update" [(ngModel)]="activeReminder" value="" >
          </div>
        </div>
      </div>
    }
    <div class="line_horizontal_container">
      <div class="line_horizontal"></div>
    </div>
    <div class="form-group">
      <label for="" class="text-form">Alerta</label>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-5">
          <label for="" class="text-form">Fecha:</label>
        </div>
        <div class="col-md-7">
          <label for="" class="text-form">Hora:</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 date-activity">
          <div class="input-group">
            <input
              class="form-control style-datepicker"
              placeholder="Seleccionar fecha"
              name="Fecha_Alert" [(ngModel)]="model2"
              #Fecha_Alert="ngModel"
              ngbDatepicker #d2="ngbDatepicker"
              [minDate]="mindate"
              [maxDate]="maxdate"
              [readonly]="true"
              [placement]="'bottom-left'"
              >
            <div class="input-group-append style-button">
              <button class="btn fas fa-calendar-alt bt" (click)="d2.toggle()" type="button"></button>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <ngb-timepicker
            [(ngModel)]="timeAlert"
            [meridian]="meridian1"
            class="timePicker"
            name="time_alert"
            >
          </ngb-timepicker>
        </div>
        <div class="col-md-2 check">
          <a type="button" class="btn style-button bt" (click)="addAlert()">
            <i class="fas fa-check"></i>
          </a>
        </div>
      </div>
      <!-- Message Success  new Alert -->
      @if (successMessageNewAlert) {
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <ngb-alert class="mt-3" type="success" (close)="successMessageNewAlert = ''">{{ successMessageNewAlert }}</ngb-alert>
            </div>
          </div>
        </div>
      }
      <!-- Message Error new Alert -->
      @if (errorMessageNewAlert) {
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <ngb-alert  class="mt-3" type="danger" (close)="errorMessageNewAlert = ''">{{ errorMessageNewAlert }}</ngb-alert>
            </div>
          </div>
        </div>
      }
    </div>
    @if (showTableAlert) {
      <div class="form-group">
        <label for="" class="text-form">Lista de Alertas:</label>
        <table class="table-borderless table-responsive pt-2" style="table-layout: fixed; width: 100%;">
          <colgroup>
          <col span="1" style="width: 30%;">
          <col span="1" style="width: 30%;">
          <col span="1" style="width: 30%;">
          <col span="1" style="width: 10%;">
        </colgroup>
        <thead>
          <tr>
            <th class="table-th">Nombre</th>
            <th class="table-th">Fecha</th>
            <th class="table-th">Hora</th>
            <th class="table-th">Acción</th>
          </tr>
        </thead>
        <tbody>
          @for (alert of alerts; track alert) {
            <tr>
              <td class="text-table">{{alert.name}}</td>
              <td class="text-table">{{alert.before_activity_date.substring(0,10).split('-').reverse().toString().replace(',','/').replace(',','/')}}</td>
              <td class="text-table">{{"Thu Oct 30 2050 " + alert.before_activity_time | date:'h:mm aaaaa\'m\''}}</td>
              <td class="text-center">
                <a type="button" class="icon-table" (click)="deleteAlert(alert.name)"><i class="far fa-trash-alt"></i></a>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <!-- Message Success delete Alert -->
      @if (successMessageDeleteAlert) {
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <ngb-alert  class="mt-3" type="success" (close)="successMessageDeleteAlert = ''">{{ successMessageDeleteAlert }}</ngb-alert>
            </div>
          </div>
        </div>
      }
    </div>
  }
  <app-add-collaborator
    (sendCollab)="retrieveCollab($event)"
    [doneReq]="sentData"
    [requirementId]="reqId"
    >
  </app-add-collaborator>
  @if (successMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert class="mt-3" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
  @if (errorMessage) {
    <div class="form-group">
      <div class="row">
        <div class="col-md-12">
          <ngb-alert  class="mt-3" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
        </div>
      </div>
    </div>
  }
  <div class="form-group">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
          (click)="activeModal.close('Close click')">
          Cerrar
        </button>
        <button type="submit"
          class="btn btn-outline-primary  rounded-pill text-dark  font-weight-bold mr-2"
          style="width: 120px;"
          >
          @if (loading) {
            <div>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Cargando...
            </div>
          }
          @if (!loading) {
            <span>
              Guardar
            </span>
          }
        </button>
      </div>
    </div>
  </div>
</form>
</div>